/**
 * "What this enables" + "Why it matters" — shared Command Center pattern.
 */
import React from 'react';
import { infoCards, cn } from './uiTokens';

interface SectionExplainerProps {
  enables: string;
  value: string;
  actions?: string[];
  className?: string;
  testId?: string;
}

const SectionExplainer: React.FC<SectionExplainerProps> = ({
  enables,
  value,
  actions = [],
  className,
  testId,
}) => (
  <div className={cn('space-y-3', className)} data-testid={testId}>
    <div className="grid gap-3 md:grid-cols-2">
      <div className={infoCards.enables}>
        <p className={infoCards.enablesLabel}>What this enables</p>
        <p className={infoCards.enablesText}>{enables}</p>
      </div>
      <div className={infoCards.value}>
        <p className={infoCards.valueLabel}>Why it matters</p>
        <p className={infoCards.valueText}>{value}</p>
      </div>
    </div>
    {actions.length > 0 && (
      <ul className="flex flex-wrap gap-1.5">
        {actions.map((action) => (
          <li key={action} className={infoCards.chip}>
            {action}
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default SectionExplainer;